import jwtDecode from 'jwt-decode';
import Cookies from 'js-cookie';
import { UserToken } from './contexts/userContext';

export const hexToRgb = (hex: string): [number, number, number] => {
    // example hex = '#ffffff'
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);

    return [r / 255, g / 255, b / 255]; // example [1, 1, 1]
};

export const generateRandomNumber = (numberOfDigits: number = 12): string => {
    const random = Math.random();
    const randomNumber = Math.floor(random * Math.pow(10, numberOfDigits));
    return randomNumber.toString().padStart(numberOfDigits, '0');
};

export function getTokenExpirationDate(): number | null {
    try {
        const cookies = Cookies.get('token');
        const decodedToken = jwtDecode<UserToken>(cookies!);
        const expirationDate = decodedToken.exp;
        const dateInMs = expirationDate * 1000; // return timestamp in ms

        return dateInMs;
    } catch (err) {
        return null;
    }
}
export function getUserFromToken(): UserToken['account'] | null {
    try {
        const cookies = Cookies.get('token');
        const decodedToken = jwtDecode<UserToken>(cookies!);

        const user = decodedToken.account;

        return user;
    } catch (err) {
        return null;
    }
}
